import React, {useEffect, useMemo, useState} from 'react';
import {handleActiveError, handleActiveToast} from "../../../../../components/sonner/ToastBasic";
import {removeLeases} from "../../../../../api/asset/AssetLeaseService";
import Search from "../../../../../components/search/Search";
import {ASSET_LEASE_LIST_HEADER} from "../../../../../components/table/header/Headers";
import SearchSection from "../../../../../components/search/SearchSection";
import {searchListener} from "../../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../../components/selector/Selector";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../../components/commonmethod/CommonMethod";
import SimmsInputSearch from "../../../../../components/input/SimmsInputSearch";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../../components/js-grid/JsGridExcelGridOpenButton";

function AssetLeaseListType({checked, data, date, pageInfo, dataHook}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: ASSET_LEASE_LIST_HEADER, exclude: []});

    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, ASSET_LEASE_LIST_HEADER, setHeader, [], () => {}, () => {}, 'lease');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "리스 상세"),
            url: `/asset/lease/${id}`,
        });
    };

    const deleteLease = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 리스를 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        await removeLeases({ids}).then(response => {
            if (response.status === 200) {
                handleActiveToast({message: "데이터가 삭제되었습니다"});
            } else if (response.status === 201) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if (response.status === 403) {
                handleActiveError({message: "권한이 없습니다."});
            } else {
                handleActiveError({message: "알 수 없는 에러 발생."});
            }
        });
        checked?.setChecked?.([]);
        refresh();
    };

    const leaseJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'lease'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} size detail date={searchDate} searchBar={{placeHolder: '리스명, 리스 계약번호, 계약 차수'}}>
                <SearchSection>
                    <Selector showLabel
                                 onChange={(value) => searchListener(handleSearch, 'company', extractObject(saveConditions), value)}
                                 data={saveConditions.company}
                                 entity={"company"} title={"업체"}>
                        <SimmsInputSearch type={'TEXT'} placeHolder={"업체명"} />
                    </Selector>
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={leaseJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {lease: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'lease')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="AssetLease" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteLease}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        disabled={ctx.disabled}
                                        onClick={() => void ctx.transferSelected()}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/asset/lease/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export default AssetLeaseListType;
